var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox--component"},[_c('div',{staticClass:"checkbox--square",class:{'checkbox__filled': _vm.value},on:{"click":_vm.onClick}},[_c('span',[_vm._v("✓")])])])}
var staticRenderFns = []

export { render, staticRenderFns }